<template>
  <section class="ya-te-bg-gray">
    <div class="co-container-md mx-auto px-4 py-20">
      <h2 class="ya-te-page-title ya-te-text-primary mb-8 text-center font-extrabold leading-normal sm:mb-12">
        こんな方におすすめです
      </h2>
      <div class="flex flex-col items-center gap-7 md:flex-row md:gap-[4.5rem]">
        <div class="w-full md:w-5/12">
          <img
            class="mx-auto"
            src="~/assets/images/YaTe/YaTeCounseling/Target/img_target.jpg"
            alt="こんな方におすすめです"
            width="398"
            height="224"
            loading="lazy"
          >
        </div>
        <div class="w-full text-center md:w-7/12 md:text-left">
          <slot name="leadCopy">
            <div class="ya-te-target mb-6 inline-block px-8 font-bold md:px-9">
              未経験から<br>エンジニアに転職したい方
            </div>
            <div class="ya-te-target inline-block px-10 font-bold md:px-9">
              ITスキルを身に付けて<br>今の仕事に活かしたい方
            </div>
          </slot>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");

.ya-te-target {
  position: relative;
  font-size: 1.25rem;
  @media (min-width: 992px) {
    font-size: 1.75rem;
  }
}

.ya-te-target::before {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0.625rem;
  height: 1.25rem;
  content: '';
  border-top: 2px solid #000;
  border-left: 2px solid #000;
}

.ya-te-target::after {
  position: absolute;
  right: 0;
  bottom: 0;
  display: block;
  width: 0.625rem;
  height: 1.25rem;
  content: '';
  border-right: 2px solid #000;
  border-bottom: 2px solid #000;
}
</style>
